export default "__VITE_ASSET__DIB8wY8A__"